import { SW_TAKEOVER_REPLY, isSwTakeoverPing } from './protocol.js';
function canPost(source) {
    return (typeof source === 'object' &&
        source !== null &&
        'postMessage' in source &&
        typeof source.postMessage === 'function');
}
function defaultContainer() {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator))
        return undefined;
    return navigator.serviceWorker;
}
/**
 * Answer the worker's takeover ping with "I can show the update prompt".
 * Unrelated messages are ignored. Returns a function that stops answering.
 */
export function answerServiceWorkerTakeoverPing(container = defaultContainer()) {
    if (!container)
        return () => undefined;
    const listener = (event) => {
        if (!isSwTakeoverPing(event.data))
            return;
        if (!canPost(event.source))
            return;
        event.source.postMessage({ type: SW_TAKEOVER_REPLY });
    };
    container.addEventListener('message', listener);
    return () => container.removeEventListener('message', listener);
}
//# sourceMappingURL=client.js.map